<template>
  <div class="goup">
    <div
      class="btn"
      :class="{ 'btn-disabled': activityInfo.activity_state == 3 }"
      >{{
        activityInfo.activity_state == 3
          ? '活动已结束'
          : '前往APP赠送小红花得好礼'
      }}
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
    </div>
    <PrizeList />
  </div>
</template>
<script>
import PrizeList from './prize-list.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  components: { PrizeList, WxOpenLaunchApp },
  data() {
    return {
      extinfo: ''
    }
  },
  computed: {
    activityInfo() {
      return this.$store.state.coachActivity2024.activityInfo
    }
  },
  created() {
    let url = location.origin + location.pathname
    this.extinfo = '/web?url=' + encodeURIComponent(url)
  },
  methods: {
    bindSend() {
      this.$store.commit('coachActivity2024/setShowSendFlowerToast', true)
    },
    bindMyPrize() {
      this.$store.commit('coachActivity2024/setMyPrizeToast', true)
    },
    bindGetFlower() {
      this.$store.commit('coachActivity2024/setTaskToast', true)
    },
    bindGetRecord() {
      this.$store.commit('coachActivity2024/setRecordToast', true)
    }
  }
}
</script>
<style lang="scss" scoped>
.goup {
  padding: 440px 10px 10px;
  .btn {
    position: relative;
    height: 53px;
    background: linear-gradient(287deg, #fc3c87 0%, #fe285e 58%, #fc5c72 100%);
    border-radius: 41px;
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .btn-disabled {
    background: rgba(255, 255, 255, 0.5);
    color: rgba(5, 11, 39, 0.5);
  }
}
</style>
